module.exports = __webpack_public_path__ + "static/media/uniformed-security.dde34149.jpg";